import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { ShButtonComponent, SHUI_MODAL_CONFIG, ShuiModalConfig, ShuiModalRef } from '@gbr-monorepo/gbr-shui';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-close-season-dialog',
    imports: [ShButtonComponent, TranslateModule],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './close-season-dialog.component.html'
})
export class CloseSeasonDialogComponent {
    protected readonly config = inject<ShuiModalConfig<{ message: string }>>(SHUI_MODAL_CONFIG);
    private readonly modalRef = inject<ShuiModalRef<string>>(ShuiModalRef);

    public onClose(result?: string): void {
        this.modalRef.close(result);
    }
}
